import { client } from 'shared';

export function listBusinessLocationStatusHistory(business_location: number) {
    return client(`api/business-location-status-history/?business_location=${business_location}`);
}
